import clsx from "clsx";
import {
  BUTTON_BASE_STYLE,
  BUTTON_SIZE_STYLE,
  BUTTON_VARIANTS_STYLE,
  type ButtonVariant,
} from "@/constants/components/button.constants";
import type {
  ComponentSize,
  IconPosition,
} from "@/constants/components/common.constants";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ComponentSize | "xs";
  icon?: React.ReactNode;
  iconPosition?: IconPosition;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  icon,
  iconPosition = "left",
  fullWidth = false,
  children,
  className,
  ...props
}) => {
  return (
    <button
      className={clsx(
        BUTTON_BASE_STYLE,
        BUTTON_VARIANTS_STYLE[variant],
        variant === "link" ? "px-0 py-0" : BUTTON_SIZE_STYLE[size],
        fullWidth && "w-full",
        className,
      )}
      {...props}
    >
      {icon && iconPosition === "left" && icon}
      {children}
      {icon && iconPosition === "right" && icon}
    </button>
  );
};

export default Button;
